import React from 'react';
import styled from 'styled-components';

import PostCard from 'components/PostCard';
import Text from 'components/Text';
import Stack from 'components/Stack';
import Row from 'components/Row';
import Container from 'components/Container';
import { PostShape } from 'utils/props';

import { color, media } from 'styles/utils';

const Section = styled.section`
  background-color: ${color('bgBlueGray')};
  padding: 0 1.5rem 4.5rem 1.5rem;
`;

const StyledPost = styled(PostCard)`
  max-width: 33%;
  ${media.max('md')} {
    max-width: 100%;
  }
`;

export default function RelatedContent({ post }) {
  return (
    <Section>
      <Container size="lg">
        <Stack gap="2rem">
          <Text variant="f4">Related Content</Text>
          <Row colGap="1rem" rowGap="1rem" breakpoint="md" justify="flex-start">
            {post.related.map((post) => (
              <StyledPost
                key={post.slug}
                title={post.title}
                subTitle={post.subcategory.title}
                image={post.featureImage}
                link={`/post/${post.slug}`}
              />
            ))}
          </Row>
        </Stack>
      </Container>
    </Section>
  );
}

RelatedContent.propTypes = {
  post: PostShape,
};
